<template>
  <v-app>
    <v-navigation-drawer :clipped="clipped" v-model="drawer" enable-resize-watcher :mobile-break-point="mobilebreakpoint" app light class="blue-grey lighten-5">

      <v-toolbar dark color="blue-grey darken-3">
        <v-list>
          <v-list-tile>
            <v-list-tile-title class="title">
              Men&uuml;
            </v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-toolbar>

      <v-divider></v-divider>

      <v-list dense class="pt-3">
        <v-list-tile
          v-for="item in items"
          :key="item.title"
          :to="{path: item.path}"
        >
          <v-list-tile-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-tile-action>

          <v-list-tile-content color="blue-grey darken-3">
            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-group
          prepend-icon="account_circle"
          value="true"
        >
          <v-list-tile slot="activator">
            <v-list-tile-title>Gewerke</v-list-tile-title>
          </v-list-tile>

          <v-list-tile
            :title="gewerk.title"
            v-for="(gewerk) in gewerke"
            :key="gewerk.title"
            :to="{path: gewerk.path}"
          >
            <v-list-tile-action>
              <v-icon v-text="gewerk.icon"></v-icon>
            </v-list-tile-action>
            <v-list-tile-title v-text="gewerk.title"></v-list-tile-title>
          </v-list-tile>
        </v-list-group>

      </v-list>

    </v-navigation-drawer>   
    <v-toolbar app>
      <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
      <v-btn icon>
        <v-img
              :src="require('./assets/ehv_logo_kl.png')"
              contain
              alt="Logo Handwerkerverbund Erfurt e.V."
        ></v-img>
      </v-btn>
      <v-toolbar-title class="headline text-uppercase">
        <span class="font-weight-light">Handwerkerverbund Erfurt</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn flat :to="{ name: 'impressum'}">Impressum</v-btn>
      <v-btn flat :to="{ name: 'datenschutz'}">Datenschutz</v-btn>
    </v-toolbar>

    <v-content>
      <v-container fluid>
        <router-view></router-view>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
// import Home from './views/Home'

function isMobileDevice() {
    return (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1);
};

export default {
  name: 'App',

  data () {
    return {
      drawer: !isMobileDevice(),
      clipped: false,
      mobilebreakpoint: '1264',
      items: [
        {
          // action: 'local_activity',
          icon: 'home',
          title: 'Home',
          path: '/',
          items: [],
        }
      ],
      gewerke: [
        // {
        //   // action: 'local_activity',
        //   icon: 'home',
        //   title: 'Elektroinstallation, Gebäudetechnik',
        //   path: '/gewerk/elektro'
        // },
        {
          // action: 'restaurant',
          icon: 'store',
          title: 'Innenausbau',
          path: '/gewerk/innenausbau'
        },
        {
          icon: 'event_seat',
          title: 'Tischler',
          path: '/gewerk/tischler'
        },
        {
          icon: 'monetization_on',
          title: 'Fördermittelberatung, Finanzierung',
          path: '/gewerk/finanzierung'
        },
        {
          icon: 'airport_shuttle',
          title: 'Baumaschinen',
          path: '/gewerk/baumaschinen'
        },
        {
          icon: 'format_paint',
          title: 'Maler, Fußbodenleger',
          path: '/gewerk/maler'
        },
        {
          icon: 'toys',
          title: 'Heizung, Sanitär, Lüftung',
          path: '/gewerk/sanitaer'
        },
        {
          icon: 'grid_on',
          title: 'Fußbodentechnik',
          path: '/gewerk/fussboden'
        },
        {
          icon: 'security',
          title: 'Gebäudetrocknung, Leckageortung',
          path: '/gewerk/gebaeudetrocknung'
        },
        {
          icon: 'view_carousel',
          title: 'Fenster, Türen, Fließen, Trockenbau',
          path: '/gewerk/bauelemente'
        }     
      ]
    }
  }
}
</script>
<style lang="less">
  @import url('https://fonts.googleapis.com/css?family=EB+Garamond|Cardo:400italic&.css');
  /* write SCSS here */

.sandbox-correct-pronounciation {
  padding: 10em 0 10em 0;
}

h1, h2, h3 {
  margin: auto;
  text-align: center;
  position: relative;

  color:#37474F;
  font-family: 'Cardo', serif;
  font-size: 2.0em;
  // font-weight: normal;
  font-weight:700;
  font-style: italic;
  letter-spacing: 0.1em;
  line-height: 2.2em;
}
h2 {
  font-size: 2.0em;
  font-style:normal;
}
h3 {
  font-size: 1.2em;
  font-style:normal;
}
h4 {
  line-height: 1.8em;
  color:#37474F;
  font-family: 'Cardo', serif;
  text-align: center;
}

em {
  font-family: 'EB Garamond', serif;
  font-size: 1.4em;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  display: block;
  font-style:normal;
  padding-top: 0.1em;
  text-shadow: 0.04em 0.04em 0 rgba(0, 0, 0, 0.1);
}

.bottom {
  font-size: 1.5em;
  letter-spacing: 0.07em;
  font-size: 1em;
  display: block;
}

ul.offer-list {
  list-style: none;
  padding: 0;
  margin: 0;
}
ul.offer-list li {
  padding-left: 1em; 
  text-indent: -1.3em;
  font-size: 1.0em;
  color:#37474F;
  // list-style-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAYAAACp8Z5+AAAAE0lEQVQIW2NkYGD4D8RwwEi6AACaVAQBULo4sgAAAABJRU5ErkJggg==");
}
ul.offer-list li::before {
  content: "■";
  padding-right:7px;
  color: #37474F; /* or whatever color you prefer */
}
hr.spacer {
    border: 0;
    border-top: 1px solid #eee;
    margin: 10px 0;
}

@media only screen and (max-width: 1264px) {
  h1 { 
    font-size: 1.7em;
  }
  em {
    font-size: 1.2em;
  }
  h2 { 
    font-size: 1.5em;
  }
  h3 { 
    font-size: 1.2em; 
  }
}

// @media only screen and (max-width: 600px) {
// Mobile
@media only screen and (max-width: 600px) {
  h1 { 
    font-size: 1.1em;
  }
  em {
    font-size: 1.2em;
  }
  h2 { 
    font-size: 1.1em;
  }
  h3 { 
    font-size: 1.0em; 
  }
}

</style>
